// src/styles/Theme.js
const theme = {
    colors: {
        primary: '#1e4b94', // Bleu Decko
        primaryLight: '#2a5cb3',
        primaryDark: '#0d3a7d',
        secondary: '#e9a826', // Accent doré/jaune
        dark: '#1a1a1a',
        light: '#ffffff',
        gray: '#f8f9fa',
        grayDark: '#343a40',
        textMain: '#2d3748',
        textLight: '#718096',
        background: '#FFFFFF'
    },
    fonts: {
        main: "'Open Sans', sans-serif", // Police principale
        heading: "'Montserrat', sans-serif", // Police pour les titres
        mono: "'Roboto Mono', monospace"
    },
    fontSizes: {
        small: '0.875rem',
        medium: '1rem',
        large: '1.125rem',
        xl: '1.5rem',
        xxl: '2rem',
        xxxl: '3rem',
        mega: '4rem'
    },
    breakpoints: {
        xs: '480px',
        sm: '768px',
        md: '992px',
        lg: '1200px'
    },
    spacing: {
        xs: '0.5rem',
        sm: '1rem',
        md: '2rem',
        lg: '3rem',
        xl: '5rem'
    },
    transitions: {
        fast: '0.3s ease-in-out',
        medium: '0.5s ease-in-out',
        slow: '0.8s ease-in-out'
    },
    borderRadius: {
        small: '4px',
        medium: '8px',
        large: '16px',
        round: '50%'
    },
    shadows: {
        small: '0 2px 5px rgba(0, 0, 0, 0.1)',
        medium: '0 4px 12px rgba(0, 0, 0, 0.15)',
        large: '0 8px 20px rgba(0, 0, 0, 0.2)',
        subtle: '0 1px 3px rgba(0, 0, 0, 0.05)'
    }
};

export default theme;